// fc-brands.js — horizontal carousel for the "Shop by brand" section.
// Vanilla custom element (no framework, per project rules). The track is a native
// CSS scroll-snap row; arrow buttons page it one card at a time and disable at the
// ends. Mobile relies on native swipe. Reduced-motion users get instant (non-smooth)
// jumps. If the cards don't overflow, the whole control rail is hidden via an attr.
class FcBrandsCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-fc-brands-track]');
    this.prevBtn = this.querySelector('[data-fc-brands-prev]');
    this.nextBtn = this.querySelector('[data-fc-brands-next]');
    if (!this.track) return;

    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.onScroll = this.onScroll.bind(this);

    this.prevBtn?.addEventListener('click', () => this.page(-1));
    this.nextBtn?.addEventListener('click', () => this.page(1));
    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });

    this.updateArrows();
  }

  disconnectedCallback() {
    this.track?.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
  }

  page(direction) {
    const card = this.track.querySelector('[data-fc-brands-panel]');
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    const step = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth * 0.8;
    this.track.scrollBy({ left: direction * step, behavior: this.reduceMotion ? 'auto' : 'smooth' });
  }

  onScroll() {
    if (this.raf) cancelAnimationFrame(this.raf);
    this.raf = requestAnimationFrame(() => this.updateArrows());
  }

  updateArrows() {
    const max = this.track.scrollWidth - this.track.clientWidth;
    const overflowing = max > 1;
    this.toggleAttribute('data-no-overflow', !overflowing);
    if (!this.prevBtn || !this.nextBtn) return;
    this.prevBtn.disabled = !overflowing || this.track.scrollLeft <= 1;
    this.nextBtn.disabled = !overflowing || this.track.scrollLeft >= max - 1;
  }
}

if (!customElements.get('fc-brands-carousel')) {
  customElements.define('fc-brands-carousel', FcBrandsCarousel);
}
